module.exports = __webpack_public_path__ + "img/Logo-Pilsa-Superior.559b5ef5.webp";